import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Div100vh from "react-div-100vh";
import Lottie from "lottie-react";
import load from "@/assets/lottie/load.json";
const LoadingScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      const res = location.state?.res;

      const pdata = location.state?.pdata;
      const status = res?.data?.status;
      if (status === "PHONE_MISMATCH") {
        const alternateNumbers = res?.data?.extractedNUmbers || [];

        navigate("/alt-phone", {
          state: { pdata: pdata, alternateNumbers: alternateNumbers },
        });
        return;
      }
      if (
        [
          "NEED_PAN",
          "VALIDATION_ERROR",
          "BUREAU_PULL_FAILED",
          "INPUT_ERROR",
          "CONFLICT",
          "ERROR",
        ].includes(status)
      ) {
        navigate("/eligibility-check");
        return;
      }
      if (status === "FAILED") {
        navigate("/declined");
        return;
      } else if (location.state?.redirectPath) {
        navigate(location.state.redirectPath);
      } else {
        navigate("/congrats");
        return;
      }
    }, 4000);

    return () => clearTimeout(timer);
  }, [navigate, location]);

  return (
    //   <Div100vh className="flex flex-col justify-evenly">
    //     <div className="flex flex-col h-1/2  justify-center">
    //       {/* <svg
    //         version="1.1"
    //         id="L7"
    //         xmlns="http://www.w3.org/2000/svg"
    //         xmlns:xlink="http://www.w3.org/1999/xlink"
    //         x="0px"
    //         y="0px"
    //         viewBox="0 0 100 100"
    //         enable-background="new 0 0 100 100"
    //         xml:space="preserve"
    //       >
    //         <path
    //           fill="#fff"
    //           d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3
    // c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
    //         >
    //           <animateTransform
    //             attributeName="transform"
    //             attributeType="XML"
    //             type="rotate"
    //             dur="2s"
    //             from="0 50 50"
    //             to="360 50 50"
    //             repeatCount="indefinite"
    //           />
    //         </path>
    //         <path
    //           fill="#fff"
    //           d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7
    // c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
    //         >
    //           <animateTransform
    //             attributeName="transform"
    //             attributeType="XML"
    //             type="rotate"
    //             dur="1s"
    //             from="0 50 50"
    //             to="-360 50 50"
    //             repeatCount="indefinite"
    //           />
    //         </path>
    //         <path
    //           fill="#1987fb"
    //           d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5
    // L82,35.7z"
    //         >
    //           <animateTransform
    //             attributeName="transform"
    //             attributeType="XML"
    //             type="rotate"
    //             dur="2s"
    //             from="0 50 50"
    //             to="360 50 50"
    //             repeatCount="indefinite"
    //           />
    //         </path>
    //       </svg> */}
    //       <Lottie className="h-[60%]" animationData={load} loop={true}/>
    //     </div>
    //     <div className="flex flex-col text-center p-4 h-1/2 gap-5">
    //       <p className="text-xl font-semibold mb-2">
    //         Loading
    //         <span className="dots">
    //           <motion.span
    //             animate={{ opacity: [0, 1] }}
    //             transition={{ repeat: Infinity, duration: 1 }}
    //           >
    //             .
    //           </motion.span>
    //           <motion.span
    //             animate={{ opacity: [0, 1] }}
    //             transition={{ repeat: Infinity, duration: 1, delay: 0.33 }}
    //           >
    //             .
    //           </motion.span>
    //           <motion.span
    //             animate={{ opacity: [0, 1] }}
    //             transition={{ repeat: Infinity, duration: 1, delay: 0.66 }}
    //           >
    //             .
    //           </motion.span>
    //         </span>
    //       </p>
    //       <div className="w-full h-1 bg-gradient-horizontal bg-[length:200%_100%] animate-gradient-animation"></div>
    //       <p className="text-sm">Just a moment! <br></br>We're verifying your details</p>
    //     </div>
    //   </Div100vh>
    <Div100vh className="flex flex-col justify-center items-center gap-12">
      {/* <img
        src="/circlepe_logo_white.svg"
        alt="logo"
        className={`mb-16 transition-opacity h-[5%] duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}
      /> */}
      <svg
        width="112"
        height="124"
        viewBox="0 0 112 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-white animate-filter z-20 h-40 transition-opacity duration-500"
      >
        <path
          d="M5.25601 37.3701L1.19934 37.3377L1.19934 37.3377L5.25601 37.3701ZM5.57254 36.8195L3.45516 33.3591L3.45515 33.3591L5.57254 36.8195ZM58.8432 4.22358L60.9606 7.68397L60.9606 7.68396L58.8432 4.22358ZM103.501 96.6964C103.501 98.9369 105.318 100.753 107.558 100.753C109.799 100.753 111.615 98.9369 111.615 96.6964L103.501 96.6964ZM59.5624 4.24154L61.8499 0.891185L61.8499 0.89118L59.5624 4.24154ZM83.3834 20.5057L85.6709 17.1553L85.6709 17.1553L83.3834 20.5057ZM107.269 36.8142L109.557 33.4638L109.557 33.4638L107.269 36.8142ZM40.6128 106.064L5.25887 106.064L5.25887 114.177L40.6128 114.177L40.6128 106.064ZM5.25887 106.064C7.5712 106.064 8.61847 107.846 8.71593 108.007C8.98056 108.443 9.0945 108.823 9.12569 108.928C9.2062 109.198 9.2325 109.402 9.23319 109.407C9.24273 109.474 9.23812 109.462 9.22788 109.307C9.20959 109.028 9.19026 108.561 9.17211 107.889C9.13628 106.562 9.10948 104.613 9.09083 102.166C9.05361 97.2788 9.04949 90.4966 9.06609 82.9364C9.09928 67.8202 9.21514 49.6411 9.31267 37.4024L1.19934 37.3377C1.10174 49.5848 0.985753 67.7809 0.952519 82.9185C0.935907 90.4852 0.939938 97.2995 0.977478 102.227C0.996215 104.687 1.02345 106.7 1.06148 108.108C1.08026 108.804 1.10281 109.398 1.13174 109.838C1.14511 110.042 1.16545 110.305 1.20134 110.556C1.2152 110.653 1.25501 110.926 1.34938 111.243C1.38751 111.371 1.50847 111.769 1.78021 112.217C1.88479 112.389 2.93925 114.177 5.25887 114.177L5.25887 106.064ZM7.68993 40.2799L60.9606 7.68397L56.7258 0.763194L3.45516 33.3591L7.68993 40.2799ZM103.501 37.3612L103.501 96.6964L111.615 96.6964L111.615 37.3612L103.501 37.3612ZM57.2749 7.5919L81.0959 23.8561L85.6709 17.1553L61.8499 0.891185L57.2749 7.5919ZM81.0959 23.8561L104.982 40.1645L109.557 33.4638L85.6709 17.1553L81.0959 23.8561ZM111.615 37.3612C111.615 35.8018 110.845 34.3431 109.557 33.4638L104.982 40.1645C104.056 39.5321 103.501 38.4828 103.501 37.3612L111.615 37.3612ZM60.9606 7.68396C59.821 8.3813 58.3783 8.34526 57.2749 7.59191L61.8499 0.89118C60.3159 -0.156163 58.3102 -0.206272 56.7258 0.763197L60.9606 7.68396ZM9.31267 37.4024C9.30284 38.6367 8.63581 39.7011 7.68994 40.2799L3.45515 33.3591C2.1191 34.1766 1.21282 35.646 1.19934 37.3377L9.31267 37.4024Z"
          fill="#EEEEEE"
        />
        <path
          d="M111.905 108.04C111.905 110.48 109.96 112.457 107.562 112.457C105.164 112.457 103.219 110.48 103.219 108.04C103.219 105.6 105.164 103.624 107.562 103.624C109.96 103.624 111.905 105.6 111.905 108.04Z"
          fill="#EEEEEE"
          stroke="#EEEEEE"
          strokeWidth="0.0911647"
        />
        <path
          d="M35.7736 75.2365C39.6185 73.8608 44.3805 73.7694 48.7956 73.7689C52.6705 74.8949 55.3218 76.6767 57.8692 79.7986L55.5998 81.7659C54.7084 80.8134 53.408 80.5499 52.0588 80.5453C51.0587 80.5419 49.9845 80.6827 48.9817 80.8142C48.5639 80.8689 48.1585 80.922 47.7761 80.9624C46.3762 80.6854 44.6106 80.6975 42.8988 80.8836C41.1698 81.0717 39.4743 81.4397 38.2369 81.8824C35.7576 82.7694 33.6307 84.4191 32.1555 86.5992C30.6804 88.7793 29.9316 91.3797 30.0134 94.0343C30.0953 96.6888 31.0036 99.2643 32.6102 101.399C34.225 103.545 36.489 104.888 39.0044 105.699C41.4996 106.504 43.8292 106.963 46.5763 106.684L46.5768 106.684L46.625 106.685L46.8089 106.689C46.968 106.693 47.1967 106.699 47.4754 106.705C48.0328 106.717 48.7905 106.731 49.5911 106.74C51.1832 106.759 52.9725 106.76 53.677 106.682C53.7088 106.678 53.7876 106.689 53.8999 106.862C54.0085 107.029 54.1088 107.294 54.1836 107.642C54.3321 108.334 54.3654 109.283 54.2211 110.243C54.0765 111.203 53.7577 112.148 53.223 112.847C52.695 113.537 51.9562 113.99 50.9371 113.99C49.2684 113.99 47.3395 114.094 45.4094 114.198C44.4346 114.251 43.4595 114.304 42.5175 114.343C41.1091 114.402 39.7717 114.431 38.6069 114.387C37.438 114.343 36.4615 114.226 35.7659 114.002C33.8309 113.378 32.2856 112.126 30.9024 110.598C29.8937 109.484 28.9835 108.237 28.0717 106.988C27.7284 106.518 27.3848 106.048 27.0356 105.584C24.535 102.261 23.1219 98.2534 22.9946 94.1244C22.8673 89.9955 24.0321 85.9531 26.3243 82.5655C28.6164 79.1779 31.921 76.6148 35.7736 75.2365Z"
          fill="#EEEEEE"
          stroke="#EEEEEE"
          strokeWidth="0.49675"
        />
        <path
          d="M49.7825 80.5343C49.985 80.7815 50.2506 80.9713 50.5582 81.0577C53.965 82.0146 60.1894 81.6553 64.9965 81.3778C67.0349 81.2601 68.8185 81.1571 70.0243 81.1755C74.2089 81.2392 78.2867 79.9969 81.6841 77.6234C85.0816 75.2499 87.6279 71.8645 88.9651 67.9433C90.3022 64.022 90.3629 59.7622 89.1387 55.7627C87.9144 51.7632 85.4667 48.2253 82.1398 45.6464C78.813 43.0674 74.7742 41.5772 70.5914 41.3853C66.4086 41.1934 61.2006 42.4752 57.7294 44.7421C54.649 46.754 51.6558 50.0262 50.4579 55.1168C50.2118 56.1627 51.0751 57.0983 52.1485 57.0498L57.376 56.8134C58.0671 56.7822 58.6642 56.3376 58.9567 55.7107C59.8713 53.7506 61.1994 52.0783 63.0395 50.8765C65.2008 49.4651 67.7637 48.7702 70.368 48.8897C72.9723 49.0092 75.4869 49.937 77.5583 51.5427C79.6297 53.1484 81.1537 55.3512 81.9159 57.8414C82.6782 60.3316 82.6404 62.9838 81.8078 65.4253C80.9753 67.8667 79.3899 69.9745 77.2746 71.4523C75.2256 72.8838 72.7881 73.2249 70.2694 73.2088C70.1068 73.2078 69.9518 73.2281 69.7921 73.2581C67.2214 73.7411 55.1756 73.7317 48.266 73.4886C46.6821 73.4329 45.6281 75.4641 46.6326 76.69L49.7825 80.5343Z"
          fill="#EEEEEE"
        />
        <path
          d="M49.7825 80.5343C49.985 80.7815 50.2506 80.9713 50.5582 81.0577C53.965 82.0146 60.1894 81.6553 64.9965 81.3778C67.0349 81.2601 68.8185 81.1571 70.0243 81.1755C74.2089 81.2392 78.2867 79.9969 81.6841 77.6234C85.0816 75.2499 87.6279 71.8645 88.9651 67.9433C90.3022 64.022 90.3629 59.7622 89.1387 55.7627C87.9144 51.7632 85.4667 48.2253 82.1398 45.6464C78.813 43.0674 74.7742 41.5772 70.5914 41.3853C66.4086 41.1934 61.2006 42.4752 57.7294 44.7421C54.649 46.754 51.6558 50.0262 50.4579 55.1168C50.2118 56.1627 51.0751 57.0983 52.1485 57.0498L57.376 56.8134C58.0671 56.7822 58.6642 56.3376 58.9567 55.7107C59.8713 53.7506 61.1994 52.0783 63.0395 50.8765C65.2008 49.4651 67.7637 48.7702 70.368 48.8897C72.9723 49.0092 75.4869 49.937 77.5583 51.5427C79.6297 53.1484 81.1537 55.3512 81.9159 57.8414C82.6782 60.3316 82.6404 62.9838 81.8078 65.4253C80.9753 67.8667 79.3899 69.9745 77.2746 71.4523C75.2256 72.8838 72.7881 73.2249 70.2694 73.2088C70.1068 73.2078 69.9518 73.2281 69.7921 73.2581C67.2214 73.7411 55.1756 73.7317 48.266 73.4886C46.6821 73.4329 45.6281 75.4641 46.6326 76.69L49.7825 80.5343Z"
          stroke="#EEEEEE"
        />
        <path
          d="M50.3232 55.9505C50.3232 54.9951 51.0977 54.2207 52.053 54.2207L56.925 54.2207C57.8804 54.2207 58.6548 54.9951 58.6548 55.9505L58.6548 96.5881C58.6548 97.5434 57.8804 98.3178 56.925 98.3178L52.053 98.3178C51.0977 98.3178 50.3232 97.5434 50.3232 96.5881L50.3232 55.9505Z"
          fill="#EEEEEE"
        />
        <path
          d="M50.3232 55.9505C50.3232 54.9951 51.0977 54.2207 52.053 54.2207L56.925 54.2207C57.8804 54.2207 58.6548 54.9951 58.6548 55.9505L58.6548 96.5881C58.6548 97.5434 57.8804 98.3178 56.925 98.3178L52.053 98.3178C51.0977 98.3178 50.3232 97.5434 50.3232 96.5881L50.3232 55.9505Z"
          stroke="#EEEEEE"
        />
      </svg>
      <div className="flex">
        <span className="">Getting things ready for you</span>
        <motion.span
          animate={{ opacity: [0, 1] }}
          transition={{ repeat: Infinity, duration: 1, delay: 0.66 }}
        >
          ...
        </motion.span>
      </div>
    </Div100vh>
  );
};

export default LoadingScreen;
